import React from 'react';

import {
    Modal, ModalHeader, ModalBody, ModalFooter,
    Button,
    FormGroup,
    Label,
    Input,
    FormFeedback,
    Row,
    Col
} from 'reactstrap';

import RGL, { WidthProvider } from "react-grid-layout";
import 'react-grid-layout/css/styles.css'
import 'react-resizable/css/styles.css'

import Isvg from 'react-inlinesvg';
import moveIcon from '../../../assets/svg/move.svg';
import moreIcon from '../../../assets/svg/more.svg';
import infoIcon from "../../../assets/svg/link-new-tab.svg";
import xIcon from '../../../assets/svg/x.svg';
import noNotifications from '../../../assets/svg/no-notif.svg';

import notesIcon from '../../../assets/svg/notes-icon.svg';

import PatientNotesPreview from '../../../components/patientNotesPreview';


import moment from 'moment';
import { API_ENDPOINT, getAgeLimit, translateAgeLimitMessage } from '../../../constants';
import ErrorModal_v2 from '../../../components/errorModal_v2';
import CustomSelectWithSearch from '../../../components/forms/fields/customSelectWithSearch';
import Checkbox from '../../../components/forms/fields/checkbox';
import DatePicker from '../../../components/forms/fields/datePicker';
import TimePickerV2 from '../../../components/forms/fields/timepicker_v2';
import { Player, Controls } from "@lottiefiles/react-lottie-player";
import EventMeetingsModal from '../../../components/eventMeetingsModal';
import SelectWithCheckbox from '../../../components/forms/fields/selectWithCheckbox';
import { isStringAValidNumber } from '../../../components/TwoFactorAuthModal';
import ErrorModal from '../../../components/errorModal';

import striptags from 'striptags';
import DoctorListComponent from '../../../components/forms/fields/doctorListComponent';
import InfoModal from '../../../components/infoModal';
import PatientModal from './patientModal';
import AddSecondParentModal from '../../../components/addSecondParentModal';
import { addMinutesToTime } from '../helper';
import PaymentMethodsField from '../../payments/components/paymentMethodsField';
import { getExtendedPaymentManagement } from '../../payments/helper';
import WebDocInfo from '../components/webDocInfo';
import UserIsNotVerifiedTooltip from '../../../components/UserIsNotVerifiedTooltip';
import ReferralContent from '../../../components/referralContent';
import ErrorModalV2 from '../../../components/errorModal_v2';
import { showStatusHistoryButton } from '../../../helpers/referral-statuses';
import ReferralStatusHistoryModal from '../../../components/referralStatusHistoryModal';


function isTimeValidString(timeString) {
    let valid = false;
    if (timeString?.length === 5) {
        const [hours, minutes] = timeString.split(":").map((x) => parseInt(x, 10));
        if (hours >= 0 && hours <= 23 && minutes >= 0 && minutes <= 59) {
            valid = true;
        }
    }


    return valid;
}


function parseJSON(response) {
    return response.json().then(json => {
        return {
            result: json,
            status: response.status
        }
    })
}
function truncateString(str) {
    if (str.length > 210) {
        return str.substring(0, 210) + '...';
    }
    return str;
}

class UpdateAdministrativeBooking extends React.Component {

    constructor(props) {
        super(props);

        this.player = React.createRef();
        this.state = {
            ...props.initialData,
            doctors: [],
            languages: [],
            clinicians: [],
            minTime: '07:00',
            maxTime: '18:00',
            meetingParticipantsList: [],

        }
        this.state.min = new Date();
        this.state.min.setHours(7, 0, 0)
        this.state.max = new Date();
        this.state.max.setHours(18, 0, 0)

    }

    generateInitialTime = () => {
        let tsNow = Math.floor(new Date().getTime() / 1000);
        const interval = 10 * 60;
        const ts = Math.ceil(tsNow / interval) * interval;

        let date = moment.unix(ts).format(this.props.dateFormat);
        let startTime = moment.unix(ts).format('HH:mm');
        let endTime = moment.unix(ts + 60 * 5).format('HH:mm');

        let data = {
            date,
            endDate: date,
            startTime,
            endTime,
            title: ''
        }

        return data;
    }
    getDoctors = () => {
        let query = {
            // entries: 10,
            // page: 0,
            group: this.props.selectedGroup,
            clinic: this.props.selectedClinic,
            // doctor: this.state.doctorId,
            // filter: this.state.searchVisitReason ? this.state.searchVisitReason : this.state.selectRevisitForm ? this.state.searchRevisitForm : '',
            // day: this.state.day ? this.state.day : new Date(),
            // view: this.state.view
        };
        let queryFields = {};
        for (var key in query) {
            if (key && key.indexOf('query-') === 0) {
                queryFields[key.replace('query-', '')] = query[key];
            }
        }

        fetch(API_ENDPOINT + '/users/subaccounts/doctors', {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify({
                page: null,
                entries: null,
                filter: query.filter,
                sortType: query.sortType,
                sortField: query.sortField,
                groupId: query.group,
                clinic: query.clinic,
                query: queryFields
            })
        }).then(res => res.json()).then((result) => {
            if (result) {
                this.setState({ doctors: result })
            }
        })


    }
    getClinicians = () => {
        const clinicId = this.props.selectedClinic;
        if (!clinicId) return;

        this.setState({ clinicians: [] }, () => {
            fetch(API_ENDPOINT + `/data/calendar/doctors/${clinicId}`, {
                method: 'GET',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                }
            }).then(parseJSON).then(({ result, status }) => {
                if (result?.clinicians?.length) {
                    this.setState({ clinicians: result.clinicians });
                }
            })
        });
    }

    setInitialData = () => {
        let setObj = {};
        const groupData = this.getGroupData();
        setObj.groupData = groupData;

        const event = this.state.event;
        if (event?.additionalDoctors) {
            setObj.doctorsList = event.additionalDoctors;
        }
        const doctorId = event?.doctor ?? null;
        setObj.doctorId = doctorId;

        this.setState(setObj, () => {
            this.getWorkingHours();
        });

        this.getDoctors();
        this.getClinicians();
        this.checkPatientNotes();
        this.getPossibleMeetingParticipantsList();

    }
    getLanguages = () => {

        fetch(API_ENDPOINT + '/languages', {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify({
                sortType: 1,
                sortField: 'key',
                query: {}
            })
        }).then(parseJSON).then(({ result, status }) => {
            if (result) {
                this.setState({ languages: result })
            }
        })

    }
    getEventData = (eventId) => {
        if (eventId?.length !== 24) return;


        fetch(API_ENDPOINT + `/data/calendar/administrative-bookings/${eventId}`, {
            method: 'GET',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            }
        }).then(parseJSON).then(({ result, status }) => {
            if (result?.error) {
                this.setState({ error: result.error?.translate(this.props.lang) })
            } else if (result?.event) {
                if (result?.event) {
                    let start = new Date(this.props.getStringDateTs(result?.event?.startTime, 'MM/DD/YYYY HH:mm'));
                    let end = new Date(this.props.getStringDateTs(result?.event?.endTime, 'MM/DD/YYYY HH:mm'));
                    let startDate = moment.unix(Math.floor(start.getTime() / 1000)).format('YYYY-MM-DD');
                    let startTime = moment.unix(Math.floor(start.getTime() / 1000)).format('HH:mm')
                    let endTime = moment.unix(Math.floor(end.getTime() / 1000)).format("HH:mm");

                    result.event.date = startDate;
                    result.event.startTime = startTime;
                    result.event.endTime = endTime;

                    if (result?.event?.additionalDoctor) {
                        result.event.isColleagueEvent = true;
                    }
                }



                this.setState({ ...result }, () => {
                    this.setInitialData();
                })
            }
        })
    }
    getPossibleMeetingParticipantsList = (callback) => {
        try {
            const clinicId = this.props.selectedClinic;

            this.setState({ meetingParticipantsList: [] }, () => {
                fetch(API_ENDPOINT + `/meetings/calendar/colleagues/${clinicId}`, {
                    method: 'GET',
                    headers: {
                        'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                        'content-type': 'application/json'
                    }
                }).then(res => res.json()).then((result) => {
                    if (result?.users) {
                        this.setState({ meetingParticipantsList: result.users }, () => {
                            callback?.(this.state.meetingParticipantsList);
                        });
                    }
                })
            })
        } catch (err) { }
    }
    googleHolidayEvents = () => {
        const groupId = this.props.selectedGroup;
        if (!groupId) return;

        this.setState({ holidayEvents: [] }, () => {

            fetch(API_ENDPOINT + '/google/holidays/events/' + groupId, {
                method: 'GET',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
            }).then(res => res.json()).then((result) => {
                if (result?.items?.length) {
                    let holidayEvents = [...result.items]
                    for (let i = 0; i < holidayEvents.length; i++) {
                        if (holidayEvents[i].date) {
                            let _start = `${holidayEvents[i].date} 08:00`;
                            let _end = `${holidayEvents[i].date} 17:00`;
                            holidayEvents[i].startTime = Math.floor(new Date(_start).getTime() / 1000);
                            holidayEvents[i].endTime = Math.floor(new Date(_end).getTime() / 1000);
                        }
                    }
                    this.setState({ holidayEvents })
                }
            })
        })

    }


    componentDidMount() {
        const eventId = this.props.eventId;

        this.getEventData(eventId);
        this.googleHolidayEvents();

    }
    componentDidUpdate(prevProps, prevState) {

    }

    getGroupData = () => {
        let selectedGroupIdx = -1;
        if (this.props.uData && this.props.selectedGroup && this.props.uData?.clinicGroups?.length) {
            for (let i = 0; i < this.props.uData.clinicGroups.length; i++) {
                if (this.props.uData.clinicGroups[i]._id == this.props.selectedGroup) {
                    selectedGroupIdx = i;
                    break;
                }
            }
        }
        let groupData = this.props?.uData?.clinicGroups?.[selectedGroupIdx];

        return groupData;
    }
    toggle = (callback) => {
        if (this.props.toggle) {
            this.props.toggle(callback);
        }

    }
    getWorkingHours = (_doctorId = null, callback) => {
        const doctorId = _doctorId ?? this.state.doctorId;
        const clinicId = this.props.selectedClinic;
        const groupId = this.props.selectedGroup;

        if (!doctorId || !clinicId || !groupId) return;

        const obj = {
            clinicianId: doctorId,
            clinicId: clinicId,
            groupId: groupId
        };

        fetch(API_ENDPOINT + `/data/calendar/clinician/working-hours`, {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify(obj)
        }).then(parseJSON).then(({ result, status }) => {

            let { minTime, maxTime } = result;
            if (!minTime) minTime = '07:00';
            if (!maxTime) maxTime = '18:00';

            let setObj = {};
            if (minTime !== this.state.minTime) {
                setObj.minTime = minTime;
            }
            if (maxTime !== this.state.maxTime) {
                setObj.maxTime = maxTime;
            }
            if (_doctorId) {
                setObj = {
                    minTransferDoctor: minTime,
                    maxTransferDoctor: maxTime
                };
            }

            if (Object.keys(setObj).length > 0) {
                this.setState(setObj, () => {
                    if (callback) {
                        callback();
                    }
                })
            }

        })
    }



    checkDoctorsAvailable = (doctorsList, modal, callback) => {
        let event;
        event = this.state.event;

        if (doctorsList) {
            let data = {
                doctorsList: doctorsList,
                startEventReservedDateOriginal: event.date + ' ' + event.startTime,
                endEventReservedDateOriginal: event.date + ' ' + event.endTime,
                startEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(event.date + ' ' + event.startTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`),
                endEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(event.date + ' ' + event.endTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`),
                eventId: event._id
            }
            fetch(API_ENDPOINT + '/working-hours/check/doctors', {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify(data)
            }).then(res => res.json()).then((result) => {
                if (result.error) {
                    this.setState({
                        errorAdditionalDoctors: result.doctorsList
                    })
                } else {
                    this.setState({ doctorsModal: false, successfullyAdditionalDoctors: modal != 4 ? true : false }, () => {

                        let _event = this.state.event;
                        _event.additionalDoctors = this.state.doctorsList;
                        this.setState({ event: _event })


                    })
                }
                if (callback) {
                    callback();
                }


            })
        }


    }
    setData = (data, callback) => {
        this.setState({ data }, () => {
            if (callback) {
                callback();
            }
        })
    }

    searchPatientWithRedirect = (SSN) => {
        const groupData = this.state.groupData;
        if (!groupData) return this.setState({ error: 'User not found in this clinic group' });

        const { enterprise, sarchPatients } = groupData;
        if (!enterprise && !sarchPatients) return this.setState({ error: 'User not found in this clinic group' });

        let obj = {
            socialSecurityNumber: SSN,
            group: this.props.selectedGroup,
            clinic: this.props.selectedClinic,
            openOnWebDoc: false,
        }
        enterprise && (obj.openOnWebDoc = true);

        fetch(API_ENDPOINT + '/users/find/patient', {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify(obj)
        }).then(res => res.json()).then((result) => {
            //result = result?.error ? result?.error : result?.length ? result[0] : null;

            if (result && result?._id) {
                const path = enterprise ? '/patients/search-enterprise' : '/patients/search';
                this.props.registerClinicGroupLogs({
                    type: 'patientProfile',
                    patient: SSN,
                });

                let state = {
                    TYPE: 'redirect',
                    redirectPatient: result,
                    redirectTabIndex: 1
                }
                enterprise && (state.redirectTabActive = 1);

                this.props?.[0]?.history?.push?.(path, state);

            } else {
                this.setState({ error: 'User not found in this clinic group' })
            }
        })
    }

    updateAdministrativeBooking = (forceUpdate = false) => {
        const event = this.state.event;
        const eventId = event?._id;
        if (!eventId || eventId.length !== 24) {
            this.setState({ creatingEvent: false });
            return;
        }
        let checkDate = new Date(event?.date?.replace(/-/g, "/") + ' ' + event?.startTime);
        let today = new Date();

        if (checkDate < today && !forceUpdate) {
            this.setState({
                wrongDateModal: true
            })
            return;
        } else {
            if (this.state.wrongDateModal) {
                this.setState({ wrongDateModal: null });
            }
        }


        let updateObj = {
            titleDoctor: event?.titleDoctor || '',
            startEventReservedDateOriginal: event?.date + ' ' + event?.startTime,
            endEventReservedDateOriginal: event?.date + ' ' + event?.endTime,
            startEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(event?.date + ' ' + event?.startTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`),
            endEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(event?.date + ' ' + event?.endTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`),
            patientNote: event?.patientNote || '',
            additionalDoctors: event?.additionalDoctors || [],
            guests: event?.guests
        };
        this.setState({
            loading: true,
            errorOverlap: null
        }, () => {
            fetch(API_ENDPOINT + `/data/calendar/administrative-bookings/update/${eventId}`, {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify(updateObj)
            }).then(res => res.json()).then((result) => {
                if (result?.errorOverlap && false) {
                    this.setState({
                        errorOverlap: {
                            data: data,
                            updateAllRecurringEvents: updateAllRecurringEvents
                        },
                        loading: false,
                        creatingEvent: false
                    })
                } else if (result.error) {
                    this.setState({
                        error: result.error.translate(this.props.lang),
                        loading: false,
                        creatingEvent: false
                    })
                } else {
                    this.setState({
                        creatingEvent: false,
                        loading: false,
                    }, () => {
                        this.toggle();

                        if (this.props.addToUpdatedEvents) {
                            this.props.addToUpdatedEvents([eventId]);
                        }
                    });
                }



            })
        })

    }
    checkPatientNotes = () => {
        const { event } = this.state;
        const eventId = event?._id || null;

        if (!eventId) {
            this.setState({ patientNotes: [] })

            return;
        }
        let obj = {
            eventId,
            clinicId: this.props.selectedClinic,
            groupId: this.props.selectedGroup,
            lang: this.props.lang
        };

        this.setState({ patientNotes: [] }, () => {
            fetch(API_ENDPOINT + `/user/patients-notes/fetch`, {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify(obj)
            }).then(res => res.json()).then((result) => {
                if (result?.items?.length) {
                    this.setState({ patientNotes: result.items });
                }
            })
        })

    }
    deleteEvent = (eventId) => {
        if (!eventId || eventId.length !== 24) return;

        this.setState({
            loadingDelete: true,
        }, () => {
            fetch(API_ENDPOINT + `/data/calendar/administrative-bookings/${eventId}`, {
                method: 'DELETE',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                }
            }).then(res => res.json()).then((result) => {
                if (result.error) {
                    this.setState({
                        error: result.error.translate(this.props.lang),
                        loadingDelete: false
                    })
                } else {
                    this.setState({
                        loadingDelete: false
                    }, () => {
                        this.toggle();
                    });
                }



            })
        })

    }
    leaveCase = () => {
        const event = this.state.event;
        const eventId = event?.eventId;
        const doctorId = this.state.doctorId;
        const condition = event?.additionalDoctors?.find(item => item === doctorId);
        if (condition && eventId) {
            let updateObj = {};
            let additionalDoctors = event?.additionalDoctors?.filter(item => item !== doctorId);
            updateObj.additionalDoctors = additionalDoctors;
            this.setState({
                loading: true,
            }, () => {
                fetch(API_ENDPOINT + `/data/calendar/administrative-bookings/update/additional-doctors/${eventId}`, {
                    method: 'POST',
                    headers: {
                        'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                        'content-type': 'application/json'
                    },
                    body: JSON.stringify(updateObj)
                }).then(res => res.json()).then((result) => {
                    if (result.error) {
                        this.setState({
                            error: result.error.translate(this.props.lang),
                            loading: false,
                        })
                    } else {
                        this.setState({
                            loading: false,
                        }, () => {
                            this.toggle();
                        });
                    }



                })
            })
        }
    }
    disableTransferIfTimeIsOutOfWorkingHours = () => {
        let transferModal = this.state.transferModal;
        if (!transferModal?.doctor) return;
        let startTimeSplit = transferModal.startTime.split(":");
        let endTimeSplit = transferModal.endTime.split(":");

        let startTimeHourMinute = Number(startTimeSplit[0]) * 60 + Number(startTimeSplit[1]);
        let endTimeHourMinute = Number(endTimeSplit[0]) * 60 + Number(endTimeSplit[1]);

        const { minTransferDoctor, maxTransferDoctor } = this.state;
        const minTransferDoctorHourMinute = Number(minTransferDoctor?.split(":")?.[0]) * 60 + Number(minTransferDoctor?.split(":")?.[1]);
        const maxTransferDoctorHourMinute = Number(maxTransferDoctor?.split(":")?.[0]) * 60 + Number(maxTransferDoctor?.split(":")?.[1]);

        if (startTimeHourMinute > maxTransferDoctorHourMinute || endTimeHourMinute > maxTransferDoctorHourMinute) {
            if (startTimeHourMinute > maxTransferDoctorHourMinute) {
                transferModal.startTime = addMinutesToTime(maxTransferDoctor, -10);
                transferModal.endTime = maxTransferDoctor;

                this.setState({
                    transferModal
                })
            } else {
                let doctor = this.state.doctors.filter(item => item._id.toString() == this.state.transferModal?.doctor)[0];
                if (doctor)
                    this.setState({
                        timeErrorMessage: `${this.props.formatName(doctor?.userData?.title, doctor?.userData?.name)}` + ' ' + 'is not available at this time.' + ' ' + 'Working hours:' + ' ' + minTransferDoctor + ' - ' + maxTransferDoctor
                    })

            }
            return true

        }
        if (startTimeHourMinute < minTransferDoctorHourMinute || endTimeHourMinute < minTransferDoctorHourMinute) {
            if (startTimeHourMinute < minTransferDoctorHourMinute) {
                transferModal.startTime = minTransferDoctor;
                transferModal.endTime = addMinutesToTime(minTransferDoctor, 10);
                this.setState({
                    transferModal
                })
            } else {
                let doctor = this.state.doctors.filter(item => item._id.toString() == this.state.transferModal?.doctor)[0];
                if (doctor)
                    this.setState({
                        timeErrorMessage: `${this.props.formatName(doctor?.userData?.title, doctor?.userData?.name)}` + ' ' + 'is not available at this time.' + ' ' + 'Working hours:' + ' ' + minTransferDoctor + ' - ' + maxTransferDoctor
                    })
            }
            return true
        }

        this.setState({
            timeErrorMessage: null
        })
        return false
    }
    transferEvent = () => {
        const transferModal = this.state.transferModal;
        if (!transferModal?.doctor) return;
        const eventId = transferModal?._id;
        if (!eventId || eventId.length !== 24) return;
        let transferObj = {
            titleDoctor: transferModal?.titleDoctor || '',
            startEventReservedDateOriginal: transferModal?.date + ' ' + transferModal?.startTime,
            endEventReservedDateOriginal: transferModal?.date + ' ' + transferModal?.endTime,
            startEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(transferModal?.date + ' ' + transferModal?.startTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`),
            endEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(transferModal?.date + ' ' + transferModal?.endTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`),
            doctor: transferModal?.doctor || null,
        };
        console.log('transferObj', transferObj);

        this.setState({
            loadingTransfer: true,
        }, () => {
            fetch(API_ENDPOINT + `/data/calendar/administrative-bookings/transfer/${eventId}`, {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify(transferObj)
            }).then(res => res.json()).then((result) => {
                if (result.error) {
                    this.setState({
                        error: result.error.translate(this.props.lang),
                        loadingTransfer: false,
                    })
                } else {
                    this.setState({
                        loadingTransfer: false,
                    }, () => {
                        this.toggle();
                    });
                }
            })
        })

    }
    updateEventIsDone = (isDone, id, doctor) => {
        fetch(API_ENDPOINT + `/working-hours/event/update-is-done/` + id, {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify({ isDone: isDone, doctor: doctor })
        }).then(res => res.json()).then((result) => {
            if (result.error) {
                this.setState({
                    error: result.error.translate(this.props.lang),
                })
            } else {
                this.toggle();
            }
        })
    }
    closeReferral = (data, action = false) => {
        if (!this.state.caseData?._id) return;
        const closeCaseActionModal = {
            data: data ? JSON.parse(JSON.stringify(data)) : null,
            function: 'closeReferral'
        }
        if (!data) data = {};
        data.selectedGroup = this.props.selectedGroup;
        data.closeConversation = true;
        data.action = action;

        this.setState({
            loading: true
        }, () => {
            fetch(API_ENDPOINT + '/referrals/close/' + this.state.caseData?._id, {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify(data)
            }).then(res => res.json()).then((result) => {
                if (result?.eventExits && result?.neededAction) {
                    this.setState({
                        closeCaseActionModal: closeCaseActionModal,
                        loading: false
                    })
                    return;
                }
                if (result?.error) {
                    this.setState({
                        error: result.error?.translate(this.props.lang),
                        loading: false
                    })
                } else {
                    this.setState({
                        openPreviewReferral: false,

                    }, () => {
                        this.toggle();
                    })
                }

            })
        })
    }
    deleteReferral = () => {
        if (!this.state.caseData?._id) {
            return;
        }
        this.setState({
            loading: true
        }, () => {
            fetch(API_ENDPOINT + '/referrals/delete/' + this.state.caseData._id, {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify({})
            }).then(res => res.json()).then((result) => {
                if (result?.error) {
                    this.setState({
                        error: result.error?.translate(this.props.lang),
                        loading: false
                    })
                } else {
                    this.setState({
                        openPreviewReferral: false,
                    }, () => {
                        this.toggle();
                    })
                }

            })
        })
    }

    render() {
        const isOpen = this.state.event?._id ? true : false;
        if (!isOpen) return null;

        const groupData = this.state.groupData;
        const enterprise = groupData?.enterprise;
        const eventMeetings = groupData?.eventMeetings ?? false;

        const canOpenProfile = enterprise || groupData?.sarchPatients ? true : false;
        const patientInfoSettings = groupData?.patientInfoSettings ?? null;

        // const AGE_LIMIT = getAgeLimit(this.props.country, this.props.selectedGroup, this.props.clinicsAgeLimitExceptions);
        // const isChild = typeof this.state.age === 'number' && this.state.age < AGE_LIMIT ? true : false;

        // const msg = translateAgeLimitMessage(
        //     "Child is under {AGE_LIMIT} years of age - Account must be connected to a parent- or legal guardian account.",
        //     this.props.lang,
        //     AGE_LIMIT
        // );
        // const msg2 = translateAgeLimitMessage(
        //     "Child is under {AGE_LIMIT} years of age - Appointments are handled by parent or legal guardian.",
        //     this.props.lang,
        //     AGE_LIMIT
        // );


        const meetingData = this.state?.meeting ?? null;
        const patientData = this.state?.patientData ?? null;

        const doctorId = this.state.doctorId ?? null;
        const disabledDoctorSelect = this.props.isOpen?.doctorId && this.props.isOpen?.disabledDoctorSelect !== false ? true : false;

        const { minTime, maxTime, minTransferDoctor, maxTransferDoctor } = this.state;

        const caseData = this.state.caseData;

        let _showStatusHistoryButton = null;
        if (caseData) {
            const showButton = showStatusHistoryButton(caseData);
            if (showButton) _showStatusHistoryButton = caseData;
        }
        const titleTooltipText = 'Administrative bookings are never seen by the patient. Colleagues can chat/video without the patient. External guests can be invited to video without the patient.'.translate(this.props.lang);

        return (
            <>
                <Modal isOpen={isOpen} size={'lg'} centered>
                    <ModalHeader className='modal-header-flex' toggle={() => this.toggle()} close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.toggle()}>&times;</button>}>
                        <Label style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                            {'Update administrative booking'.translate(this.props.lang)}
                            <div className="parent-tooltip update-administrative-booking-tooltip">
                                <Isvg src={infoIcon} className="info-text" />
                                <div className="chat-icons-tooltip">
                                    {titleTooltipText}
                                </div>
                            </div>
                        </Label>
                        <div className='tooltip-title'>
                            {
                                this.state.event?.createOnWebDoc ?
                                    <Col lg='12'>
                                        <div className='flex-end mb-5'>
                                            <WebDocInfo lang={this.props.lang} bottomTooltip={true} />
                                        </div>
                                    </Col>
                                    :
                                    null
                            }
                            {/* {
                                this.state.event.patientProfile && !this.state.event.patientProfile?.phone && !this.state.event.patientProfile?.email ?
                                    <div className='patient-no-notif'>
                                        <Isvg src={noNotifications} width={20} height={20} />
                                        <div>
                                            {'Phone and email not registered'.translate(this.props.lang)}
                                        </div>
                                        <div className='tooltip-text'>{'No contact details registered. Add information in the patient profile to send notifications.'.translate(this.props.lang)}</div>
                                    </div>
                                    :
                                    null
                            } */}
                        </div>

                    </ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col lg="6">
                                <FormGroup>
                                    <Label>{'Title'.translate(this.props.lang)}</Label>
                                    <Input
                                        disabled
                                        type='textarea'
                                        value={this.state.event.titleDoctor && this.state.event.titleDoctor != '' ? this.state.event.title + ', ' + this.state.event.titleDoctor : this.state.event.title}
                                    />
                                    <Input
                                        type='text'
                                        style={{ marginTop: 5 }}
                                        onChange={(e) => {
                                            let event = this.state.event;
                                            event.titleDoctor = striptags(e.target.value);
                                            this.setState({
                                                event
                                            })
                                        }}
                                        value={this.state.event.titleDoctor}
                                    />

                                </FormGroup>
                                <DatePicker
                                    label={'Start date'.translate(this.props.lang)}
                                    value={this.state.event.date}
                                    disabled={this.state.event?.isColleagueEvent}
                                    holidayEvents={this.state.holidayEvents}
                                    lang={this.props.lang}
                                    onChange={(e) => {
                                        let event = this.state.event;
                                        event.date = e;
                                        this.setState({
                                            event
                                        })
                                        if (Math.floor(new Date(this.state.event.date + ' ' + this.state.event.startTime) / 1000) > Math.floor(new Date(this.state.event.endDate + ' ' + this.state.event.endTime) / 1000)) {
                                            event.endDate = this.state.event.date
                                            this.setState({
                                                event
                                            })
                                        }
                                    }}
                                />
                                <Row>
                                    <Col xs={12} sm={eventMeetings && this.state.event?.type === 'event' && this.state.event?.meeting?._id && this.state.event?.meeting?.meetingHost?.length > 1 ? 4 : 12}>
                                        <FormGroup className="timepicker-container timepicker-wide">
                                            <Label>{'Start time'.translate(this.props.lang)}</Label>
                                            &nbsp;
                                            <TimePickerV2
                                                getStringDateTs={this.props.getStringDateTs}
                                                format={'HH:mm'}
                                                disabled={this.state.event?.isColleagueEvent}
                                                value={this.state.event.startTime}
                                                minValue={minTime}
                                                maxValue={addMinutesToTime(maxTime, -5)}
                                                flag={0}
                                                onChange={(time1, timeString) => {

                                                    let event = this.state.event;
                                                    event.startTime = timeString

                                                    let startTimeSplit = event.startTime.split(":");
                                                    let endTimeSplit = event.endTime.split(":");

                                                    let startTimeHourMinute = Number(startTimeSplit[0]) * 60 + Number(startTimeSplit[1]);
                                                    let endTimeHourMinute = Number(endTimeSplit[0]) * 60 + Number(endTimeSplit[1]);

                                                    if (startTimeHourMinute < endTimeHourMinute) {
                                                        this.setState({ event })
                                                    } else {
                                                        event.endTime = Math.trunc((Number(this.state.event.startTime.split(':')[0]) * 60 + Number(this.state.event.startTime.split(':')[1]) + 5) / 60) + ":" + (Number(this.state.event.startTime.split(':')[0]) * 60 + Number(this.state.event.startTime.split(':')[1]) + 5) % 60
                                                        const padded = event?.endTime?.split?.(':');
                                                        if (padded && Array.isArray(padded) && padded.length && isStringAValidNumber(padded[0]) && isStringAValidNumber(padded[1])) {
                                                            const h = padded[0]?.padStart?.(2, '0');
                                                            const m = padded[1]?.padStart?.(2, '0');
                                                            if (h && m) event.endTime = `${h}:${m}`;
                                                        }
                                                        this.setState({
                                                            event
                                                        })
                                                    }
                                                }}
                                            />
                                        </FormGroup>
                                        <FormGroup className="timepicker-container timepicker-wide">
                                            <Label>{'End time'.translate(this.props.lang)}</Label>
                                            &nbsp;
                                            <TimePickerV2
                                                getStringDateTs={this.props.getStringDateTs}
                                                format={'HH:mm'}
                                                disabled={this.state.event?.isColleagueEvent}
                                                value={this.state.event.endTime}
                                                minValue={Math.trunc((Number(this.state.event.startTime.split(':')[0]) * 60 + Number(this.state.event.startTime.split(':')[1]) + 5) / 60) + ":" + (Number(this.state.event.startTime.split(':')[0]) * 60 + Number(this.state.event.startTime.split(':')[1]) + 5) % 60}
                                                maxValue={maxTime}
                                                flag={0}
                                                onChange={(time1, timeString) => {

                                                    let event = this.state.event;
                                                    event.endTime = timeString

                                                    let startTimeSplit = event.startTime.split(":");
                                                    let endTimeSplit = event.endTime.split(":");

                                                    let startTimeHourMinute = Number(startTimeSplit[0]) * 60 + Number(startTimeSplit[1]);
                                                    let endTimeHourMinute = Number(endTimeSplit[0]) * 60 + Number(endTimeSplit[1]);

                                                    if (startTimeHourMinute < endTimeHourMinute) {
                                                        this.setState({ event })
                                                    } else {
                                                        // this.setState({ wrongInput: true })
                                                    }
                                                }}
                                            />
                                        </FormGroup>
                                    </Col>

                                </Row>
                                {this.state.event?.doctorName ? <FormGroup>
                                    <Label>{'Clinician'.translate(this.props.lang)}</Label>
                                    <Input
                                        type='text'
                                        value={this.state.event?.doctorName}
                                        disabled={true}
                                    />
                                </FormGroup> : null}
                                {this.state.event?.additionalDoctorNames?.length ? <FormGroup>
                                    <Label>{'Additional doctors'.translate(this.props.lang)}</Label>
                                    <Input
                                        type='text'
                                        value={this.state.event?.additionalDoctorNames.join(', ')}
                                        disabled={true}
                                    />
                                </FormGroup> : null}

                                <FormGroup>
                                    <Label className='note-label-wrap'>{'Note'.translate(this.props.lang)}
                                        <div className={this.state.patientNotes?.length ? 'notes-icon-wrap notes-icon-active' : 'notes-icon-wrap'} onClick={() => { this.setState({ showPatientNotes: true }) }}>
                                            <Isvg src={notesIcon} />
                                            <div className='tooltip-text'>{'Notes available'.translate(this.props.lang)}</div>
                                        </div>
                                    </Label>
                                    <Input
                                        type='textarea'
                                        name="note"
                                        style={{ height: '150px' }}
                                        onChange={(e) => {
                                            let event = this.state.event;
                                            event.patientNote = striptags(e.target.value);
                                            this.setState({
                                                event
                                            })
                                        }}
                                        value={this.state.event.patientNote}
                                    />
                                </FormGroup>

                            </Col>
                            <Col lg="6">
                                <FormGroup>
                                    <Label>{'Case ID'.translate(this.props.lang)}</Label>
                                    <Input type='text' disabled
                                        value={this.state.patientData.referralNumber} />
                                </FormGroup>
                                <FormGroup className='form-with-search-patient'>
                                    <Label>{'Social security number'.translate(this.props.lang)} {this.state.patientData?._2fa ? <UserIsNotVerifiedTooltip warning lang={this.props.lang} /> : null}</Label>
                                    <Input type='text' disabled
                                        value={this.state.patientData.ssn} />
                                    {canOpenProfile ? <button
                                        className='form-with-search-patient-button'
                                        type='button'
                                        onClick={() => {
                                            this.toggle(() => {
                                                this.searchPatientWithRedirect(this.state.patientData.ssn);
                                            });
                                        }}
                                    >
                                        <svg enableBackground="new 0 0 24 24;" version="1.1" viewBox="0 0 24 24" xmlSpace="preserve" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"><g id="info" /><g id="icons"><g id="user"><ellipse cx="12" cy="8" rx="5" ry="6" /><path d="M21.8,19.1c-0.9-1.8-2.6-3.3-4.8-4.2c-0.6-0.2-1.3-0.2-1.8,0.1c-1,0.6-2,0.9-3.2,0.9s-2.2-0.3-3.2-0.9    C8.3,14.8,7.6,14.7,7,15c-2.2,0.9-3.9,2.4-4.8,4.2C1.5,20.5,2.6,22,4.1,22h15.8C21.4,22,22.5,20.5,21.8,19.1z" /></g></g></svg>
                                        <span>{'Go to patient profile'.translate(this.props.lang)}</span>
                                        {
                                            !this.state.event.patientProfile?.phone && !this.state.event.patientProfile?.email ?
                                                <div className='orange-curcle'></div>
                                                :
                                                null
                                        }
                                    </button> : null}
                                </FormGroup>
                                {
                                    patientInfoSettings?.isCustomIdEnabled ?
                                        <FormGroup>
                                            <Label>{patientInfoSettings?.customIdLabel ? patientInfoSettings?.customIdLabel : 'Custom id'.translate(this.props.lang)}</Label>
                                            <Input type='text' disabled value={this.state.patientData?.customId ?? 'N/A'} />
                                        </FormGroup>
                                        :
                                        null
                                }
                                <FormGroup>
                                    <Label>{'Name'.translate(this.props.lang)}</Label>
                                    <Input type='text' disabled
                                        value={this.state.patientData?.name} />
                                </FormGroup>
                                {
                                    this.state.patientData?.parents?.length ?
                                        <FormGroup>
                                            <Label>{'Legal guardian/parent'.translate(this.props.lang)}</Label>
                                            <Input type='text' style={{ marginTop: 5 }} disabled
                                                value={`${this.state.patientData?.parents?.[0].name}${this.state.patientData?.parents?.[1]?.name ? ', ' + this.state.patientData?.parents?.[1].name : ''}`} />
                                        </FormGroup>
                                        :
                                        null
                                }
                                <FormGroup>
                                    <Label>{'Email'.translate(this.props.lang)}</Label>
                                    <Input type='text' disabled
                                        value={this.state.patientData?.email} />
                                </FormGroup>
                                <FormGroup>
                                    <Label>{'Phone'.translate(this.props.lang)}</Label>
                                    <Input type='text' disabled
                                        value={this.state.patientData?.phone} />
                                </FormGroup>
                                <FormGroup>
                                    <Label>{'Address'.translate(this.props.lang)}</Label>
                                    <Input type='text' disabled
                                        value={this.state.patientData?.address} />
                                </FormGroup>

                                {eventMeetings && meetingData?._id && meetingData?.meetingHost?.length > 1 ? <div
                                    className='event-meeting-participants-wrapper'
                                >
                                    <button
                                        type='button'
                                        className={`event-meeting-participants-button ${this.state.meetingParticipants?.meetingId === meetingData?._id ? 'event-meeting-participants-button-expanded' : ''}`}
                                        onClick={() => {

                                            if (this.state.meetingParticipants) return this.setState({
                                                meetingParticipants: null
                                            });

                                            if (meetingData) {
                                                const meeting = meetingData;

                                                let hostId;
                                                let participantIds = [];

                                                if (meeting?.meetingHost && Array.isArray(meeting?.meetingHost) && meeting?.meetingHost.length) {
                                                    const newArr = [...new Set(meeting?.meetingHost)];
                                                    hostId = newArr[0];
                                                    if (newArr.length > 1) {
                                                        participantIds = newArr.slice(1);
                                                    }
                                                }

                                                let meetingParticipants = [];

                                                if (hostId) {
                                                    const user = this.state.meetingParticipantsList.find(item => item._id === hostId);
                                                    if (!user) return;

                                                    meetingParticipants.push(`<span>${this.props.formatName?.(user.userData?.title, user.userData?.name)} <strong>(${'Organizer'.translate(this.props.lang)})</strong></span>`);
                                                } else {
                                                    return;
                                                }

                                                if (participantIds?.length) {
                                                    for (const userId of participantIds) {
                                                        const user = this.state.meetingParticipantsList.find(item => item._id === userId);
                                                        if (!user) continue;

                                                        meetingParticipants.push(`<span>${this.props.formatName?.(user.userData?.title, user.userData?.name)}</span>`);
                                                    }
                                                }

                                                if (meetingParticipants?.length) {
                                                    this.setState({
                                                        meetingParticipants: {
                                                            meetingId: meeting._id,
                                                            list: meetingParticipants,
                                                        },
                                                    })
                                                }
                                            }
                                        }}
                                    >
                                        <p>{'Meeting participants'.translate(this.props.lang)}</p>
                                        <span>&gt;</span>
                                    </button>
                                    {this.state.meetingParticipants?.meetingId === meetingData?._id ? <ul className='event-meeting-participants-list'>
                                        {this.state.meetingParticipants.list.map((item, index) => {
                                            return <li
                                                key={index}
                                            >
                                                <div dangerouslySetInnerHTML={{ __html: item }} />
                                            </li>
                                        })}
                                    </ul> : null}
                                </div> : null}
                            </Col>

                            <Col lg="12">

                                {
                                    this.state.event?.isColleagueEvent ?
                                        <div className='info-message-wrap'>
                                            *{'You have been added as a colleague for this event. Only limited options are available for your access.'.translate(this.props.lang)}
                                        </div>
                                        :
                                        null
                                }


                                <div className='calendar-modal-buttons-wrap'>
                                    {
                                        !this.state.event?.isColleagueEvent && !this.state.event?.additionalDoctor ?
                                            <Button onClick={() => {
                                                this.setState({
                                                    doctorsModal: 1
                                                })
                                            }} color="primary">
                                                {'Add caregiver'.translate(this.props.lang)}
                                            </Button>
                                            :
                                            null
                                    }


                                    {

                                        eventMeetings ?
                                            <>
                                                {
                                                    !this.state.event?.isColleagueEvent ?

                                                        <FormGroup style={{ marginBottom: 0 }}>
                                                            <Button
                                                                onClick={() => {
                                                                    let guests = [];
                                                                    if (this.state.event?.guests) {
                                                                        guests = [...this.state.event.guests];
                                                                    }
                                                                    this.setState({
                                                                        eventMeetingsModal: { ...this.state.event, guests, modal: 'administrativeBooking' },
                                                                        meetingParticipants: null,
                                                                    })
                                                                }}
                                                                color="primary"
                                                            >
                                                                {'Add guest'.translate(this.props.lang)}
                                                            </Button>
                                                        </FormGroup>
                                                        :
                                                        null
                                                }
                                                {
                                                    meetingData?._id && this.state.event?.isColleagueEvent ?
                                                        <FormGroup style={{ marginBottom: /*this.state.event?.isColleagueEvent ? 10 :*/ 0 }} className='start-video-call-meeting-btn-wrap calendar-video-start-tooltip'>
                                                            <Button
                                                                disabled={!meetingData?.active}
                                                                onClick={() => {
                                                                    const conversationId = meetingData?._id;
                                                                    this.props[0].history.push(`/chat?conversation=${conversationId}`);
                                                                }}
                                                                color="primary"
                                                            >
                                                                <div className="quick-phrase-tooltip-on">
                                                                    {'Chat'.translate(this.props.lang)}
                                                                </div>
                                                            </Button>
                                                        </FormGroup>
                                                        :
                                                        null
                                                }
                                                {
                                                    meetingData?._id && this.state.event?.isColleagueEvent ?
                                                        <FormGroup style={{ marginBottom: /*this.state.event?.isColleagueEvent ? 10 :*/ 0 }} className='start-video-call-meeting-btn-wrap calendar-video-start-tooltip'>
                                                            <Button
                                                                disabled={!meetingData?.active}
                                                                onClick={() => {
                                                                    if (meetingData?.active) {
                                                                        const conversationId = meetingData?._id;
                                                                        this.props.startVideoCall(conversationId)
                                                                    }
                                                                }}
                                                                color="primary"
                                                            >
                                                                <div className="quick-phrase-tooltip-on">
                                                                    {'Start video'.translate(this.props.lang)}
                                                                    <div className="chat-icons-tooltip">{'Please note that by starting a video call, you will also open a chat with the participant(s). You can see and close this chat after the video call on the "Chat"-page.'.translate(this.props.lang)}</div>
                                                                </div>
                                                            </Button>
                                                            {
                                                                !meetingData?.active && meetingData?.message ?
                                                                    <div className='button-tooltip-wrap'>
                                                                        {meetingData.message?.translate(this.props.lang)}
                                                                    </div>
                                                                    :
                                                                    null
                                                            }
                                                        </FormGroup>
                                                        :
                                                        null
                                                }

                                            </>

                                            :

                                            null
                                    }

                                </div>
                            </Col>
                            <Col lg="12" className='align-buttons-footer'>



                                <div className='update-event-btns-wrap'>

                                    {/* {
                                        this.state.offerData
                                            && this.state.startedVideoCallConversation
                                            && this.state.event.additionalDoctors
                                            && this.state.event.additionalDoctors.filter(item => item == this.props.uData._id).length ?
                                            <Button
                                                color='primary'
                                                onClick={() => {
                                                    this.answerCall(this.state.offerData[this.state.startedVideoCallConversation])

                                                }}>{'Join video call'.translate(this.props.lang)}</Button>
                                            :
                                            null
                                    } */}
                                    {/* {
                                        !this.state.event?.meeting?._id && !this.state.event?.isColleagueEvent && this.state.event.patientProfile && (!this.state.event.additionalDoctors || (this.state.event.additionalDoctors && !this.state.event.additionalDoctors.filter(item => item == this.props.uData._id).length)) ?
                                            <div className='start-video-call-btn-wrap calendar-video-start-tooltip'>
                                                <button className={this.state.waitingRoom?.patientId === this.state.event?.patientId && this.state.waitingRoom?.showInfoWaitingRoom ? 'start-video-btn patient-waiting-room' : 'start-video-btn'} style={{ padding: 6, paddingLeft: 12, paddingRight: 12, height: 'auto' }} onClick={() => {
                                                    this.startVideoCall(this.state.event)

                                                }}>

                                                    <div className="quick-phrase-tooltip-on">
                                                        {'Start video chat'.translate(this.props.lang)}
                                                        <div className="chat-icons-tooltip">{'Please note that by starting a video call, you will also open a chat with the participant(s). You can see and close this chat after the video call on the "Chat"-page.'.translate(this.props.lang)}</div>
                                                    </div>
                                                </button>

                                            </div>
                                            :
                                            null
                                    } */}
                                    {
                                        meetingData?._id && !this.state.event?.isColleagueEvent ?
                                            <FormGroup style={{ marginBottom: /*this.state.event?.isColleagueEvent ? 10 :*/ 0 }} className='start-video-call-meeting-btn-wrap calendar-video-start-tooltip'>
                                                <Button
                                                    disabled={!meetingData?.active}
                                                    onClick={() => {
                                                        const conversationId = meetingData?._id;
                                                        this.props[0].history.push(`/chat?conversation=${conversationId}`);
                                                    }}
                                                    color="primary"
                                                >
                                                    <div className="quick-phrase-tooltip-on">
                                                        {'Chat'.translate(this.props.lang)}
                                                    </div>
                                                </Button>
                                            </FormGroup>
                                            :
                                            null
                                    }
                                    {
                                        meetingData?._id && !this.state.event?.isColleagueEvent ?
                                            <FormGroup style={{ marginBottom: /*this.state.event?.isColleagueEvent ? 10 :*/ 0 }} className='start-video-call-meeting-btn-wrap calendar-video-start-tooltip'>
                                                <Button
                                                    disabled={!meetingData?.active}
                                                    onClick={() => {
                                                        if (meetingData?.active) {
                                                            const conversationId = meetingData?._id;
                                                            this.props.startVideoCall(conversationId)
                                                        }
                                                    }}
                                                    color="primary"
                                                >
                                                    <div className="quick-phrase-tooltip-on">
                                                        {'Start video'.translate(this.props.lang)}
                                                        <div className="chat-icons-tooltip">{'Please note that by starting a video call, you will also open a chat with the participant(s). You can see and close this chat after the video call on the "Chat"-page.'.translate(this.props.lang)}</div>
                                                    </div>
                                                </Button>
                                                {
                                                    !meetingData?.active && meetingData?.message ?
                                                        <div className='button-tooltip-wrap'>
                                                            {meetingData.message?.translate(this.props.lang)}
                                                        </div>
                                                        :
                                                        null
                                                }
                                            </FormGroup>
                                            :
                                            null
                                    }

                                    {
                                        !this.state.event?.isColleagueEvent
                                            && !this.state.event.additionalDoctor
                                            &&
                                            (
                                                this.props.uData?.groupPermissionsUser?.[this.props.selectedGroup]?.[this.props.selectedClinic]?.includes(this.props.uData?.permissions?.admin)
                                                || this.props.uData?.groupPermissionsUser?.[this.props.selectedGroup]?.[this.props.selectedClinic]?.includes(this.props.uData?.permissions?.scheduler)
                                            )
                                            ?
                                            <Button color='primary'
                                                style={{
                                                }}
                                                onClick={() => {
                                                    this.setState({
                                                        transferModal: { ...this.state.event, doctor: null },
                                                        // event: !this.state.event,
                                                        // meetingParticipants: null,
                                                        // prevUpdateEvent: !this.state.prevUpdateEvent,
                                                        // doctorsList: []
                                                    })
                                                }}
                                            >
                                                {'Transfer'.translate(this.props.lang)}
                                            </Button>
                                            :
                                            null
                                    }
                                    {
                                        !this.state.event?.isColleagueEvent && !this.state.event.additionalDoctor ?
                                            <Button
                                                color='primary'
                                                style={{
                                                }}
                                                onClick={() => {
                                                    let setObj = {};
                                                    let deleteEventModal = { ...this.state.event };
                                                    setObj.deleteEventModal = deleteEventModal;
                                                    this.setState(setObj)


                                                }}
                                            >
                                                {'Cancel time'.translate(this.props.lang)}
                                            </Button>

                                            :
                                            null
                                    }
                                    {
                                        this.state.event?.isColleagueEvent
                                            && this.state.event.additionalDoctors
                                            && this.state.event.additionalDoctors.filter(item => item === doctorId).length ?
                                            <Button
                                                color='primary'
                                                style={{
                                                }}
                                                onClick={() => {
                                                    this.setState({ leaveCaseModal: { ...this.state.event } })

                                                }}
                                            >
                                                {'Leave case'.translate(this.props.lang)}
                                            </Button>
                                            :
                                            null
                                    }
                                    {/* {
                                        this.state.event?.isColleagueEvent && this.state.event.type === 'event' && this.state.event?.doctor !== this.props.uData?._id ?
                                            <Button
                                                color='primary'
                                                style={{
                                                    //  marginBottom: 10
                                                }}
                                                onClick={() => {

                                                    let setObj = { event: !this.state.event, meetingParticipants: null, prevUpdateEvent: !this.state.prevUpdateEvent, doctorsList: [] };
                                                    let deleteColleagueEventModal = { ...this.state.event };
                                                    setObj.deleteColleagueEventModal = deleteColleagueEventModal;
                                                    this.setState(setObj)
                                                }}
                                            >
                                                {'Cancel time'.translate(this.props.lang)}
                                            </Button>

                                            :
                                            null
                                    } */}
                                    {/* {
                                        eventMeetings ?
                                            <>

                                                {
                                                    this.state.event?.meeting?._id ?
                                                        <FormGroup style={{
                                                            marginBottom: 0,
                                                        }} className='start-video-call-meeting-btn-wrap calendar-video-start-tooltip'>
                                                            <Button
                                                                disabled={!this.state.event?.meeting?.active}
                                                                onClick={() => {
                                                                    if (this.state.event?.meeting?.active) {
                                                                        const conversationId = this.state.event?.meeting?._id;
                                                                        this.props.startVideoCall(conversationId)
                                                                    }
                                                                }}
                                                                color="primary"
                                                            >
                                                                <div className="quick-phrase-tooltip-on">
                                                                    {'Start video'.translate(this.props.lang)}
                                                                    <div className="chat-icons-tooltip">{'Please note that by starting a video call, you will also open a chat with the participant(s). You can see and close this chat after the video call on the "Chat"-page.'.translate(this.props.lang)}</div>
                                                                </div>
                                                            </Button>
                                                            {
                                                                !this.state.event?.meeting?.active && this.state.event?.meeting?.message ?
                                                                    <div className='button-tooltip-wrap'>
                                                                        {this.state.event.meeting.message?.translate(this.props.lang)}
                                                                    </div>
                                                                    :
                                                                    null
                                                            }
                                                        </FormGroup>
                                                        :
                                                        null
                                                }
                                                {
                                                    meetingData?._id ?
                                                        <FormGroup style={{ marginBottom: this.state.event?.isColleagueEvent ? 10 : 0 }} className='start-video-call-meeting-btn-wrap calendar-video-start-tooltip'>
                                                            <Button
                                                                disabled={!meetingData?.active}
                                                                onClick={() => {
                                                                    const conversationId = meetingData?._id;
                                                                    this.props[0].history.push(`/chat?conversation=${conversationId}`);
                                                                }}
                                                                color="primary"
                                                            >
                                                                <div className="quick-phrase-tooltip-on">
                                                                    {'Chat'.translate(this.props.lang)}
                                                                </div>
                                                            </Button>
                                                        </FormGroup>
                                                        :
                                                        null
                                                }
                                            </>

                                            :

                                            null
                                    } */}

                                    {
                                        caseData ?
                                            <Button color='primary'
                                                style={{
                                                }}
                                                onClick={() => this.setState({ openPreviewReferral: true })}>{'Case preview'.translate(this.props.lang)}</Button>

                                            :
                                            null
                                    }
                                    {
                                        _showStatusHistoryButton && caseData ? <Button
                                            color='primary'
                                            style={{ padding: 6, paddingLeft: 12, paddingRight: 12 }}
                                            onClick={() => {
                                                this.setState({ statusHistoryModal: _showStatusHistoryButton })
                                            }}
                                        >
                                            {'View history'.translate(this.props.lang)}
                                        </Button> : null
                                    }

                                </div>
                                <div>

                                    <Button
                                        color='danger'
                                        style={{ marginRight: 10 }}
                                        onClick={() => {
                                            this.toggle();
                                        }}
                                    >
                                        {'Cancel'.translate(this.props.lang)}
                                    </Button>

                                    {
                                        !this.state.event?.isColleagueEvent && !this.state.event.additionalDoctor ?
                                            <Button
                                                color='success'
                                                style={{ marginRight: 10 }}
                                                disabled={this.state.creatingEvent ? true : false}
                                                onClick={() => {
                                                    this.setState({ creatingEvent: true }, () => {
                                                        this.updateAdministrativeBooking()
                                                    })
                                                }}
                                            >
                                                {this.state.loading ?

                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                        <Player
                                                            onEvent={() => {
                                                                if (!this.state.loading) this.stopAnimation();
                                                            }}
                                                            onStateChange={this.toggleVisibility}
                                                            ref={this.player} // set the ref to your class instance
                                                            autoplay={true}
                                                            loop={true}
                                                            controls={true}
                                                            src="https://assets8.lottiefiles.com/packages/lf20_ZSRKCF.json"
                                                            style={{ height: "20px", width: "30px" }}
                                                        ></Player>
                                                        {'Processing...'.translate(this.props.lang)}
                                                    </div>

                                                    : 'Save changes'.translate(this.props.lang)}
                                            </Button>
                                            :
                                            null
                                    }
                                    {
                                        this.state.event?.isMarkedAsDone ?
                                            <Button onClick={() => {
                                                let event = this.state.event;
                                                event.isMarkedAsDone = false
                                                this.setState({
                                                    event
                                                }, () => {
                                                    this.updateEventIsDone(false, this.state.event?._id, this.state.doctorId)
                                                })
                                            }} color='primary'>{'Mark as undone'.translate(this.props.lang)}</Button>
                                            :
                                            <Button onClick={() => {
                                                let event = this.state.event;
                                                event.isMarkedAsDone = true
                                                this.setState({
                                                    event
                                                }, () => {
                                                    this.updateEventIsDone(true, this.state.event?._id, this.state.doctorId)
                                                })
                                            }} color='primary'>{'Mark as done'.translate(this.props.lang)}</Button>
                                    }
                                </div>




                            </Col>
                            <Col lg='12' style={{ marginTop: 15 }}>
                                {
                                    this.state.event?.tsCreated && this.state.event?.tsModified && this.state.event?.tsCreated !== this.state.event?.tsModified ?
                                        <div className='info-message-update-wrap'>
                                            {`${'Created on:'.translate(this.props.lang)} ${this.props.getStringDateTs(this.state.event?.tsCreated, `${this.props.dateFormat} HH:mm`)}. ${'Last update:'.translate(this.props.lang)} ${this.props.getStringDateTs(this.state.event?.tsModified, `${this.props.dateFormat} HH:mm`)}`}
                                        </div>
                                        :
                                        this.state.event?.tsCreated ?
                                            <div className='info-message-update-wrap'>
                                                {`${'Created on:'.translate(this.props.lang)} ${this.props.getStringDateTs(this.state.event?.tsCreated, `${this.props.dateFormat} HH:mm`)}`}
                                            </div>
                                            :
                                            null

                                }
                            </Col>
                        </Row>

                    </ModalBody>
                </Modal>

                {
                    this.state.eventMeetingsModal ?
                        <EventMeetingsModal
                            {...this.props}
                            data={this.state.eventMeetingsModal}
                            doctorId={this.state.doctorId}
                            onClose={() => this.setState({ eventMeetingsModal: null })}
                            closeButtonText={'Close without saving'.translate(this.props.lang)}
                            saveData={(data) => {
                                let setObj = { eventMeetingsModal: null };
                                let modal = this.state.eventMeetingsModal?.modal;
                                console.log('saving event meetings data:', data, modal);
                                if (data && modal) {
                                    if (modal === 'administrativeBooking') {
                                        let eventObj = this.state.event;
                                        eventObj.guests = data;
                                        this.setData(eventObj)
                                    }
                                }
                                this.setState(setObj)
                            }}
                        />
                        :
                        null
                }
                {
                    this.state.successfullyAdditionalDoctors ?
                        <InfoModal
                            isOpen={this.state.successfullyAdditionalDoctors}
                            toggle={() => this.setState({ successfullyAdditionalDoctors: !this.state.successfullyAdditionalDoctors })}
                            header={'Info'.translate(this.props.lang)}
                            info={`All doctors were successfully added`.translate(this.props.lang)}
                            buttons={[
                                <Button color="primary" style={{ margin: 10 }} onClick={() => this.setState({ successfullyAdditionalDoctors: false })}>{'Ok'.translate(this.props.lang)}</Button>,

                            ]}

                        />
                        :
                        null
                }
                {
                    this.state.doctorsModal ?
                        <Modal isOpen={this.state.doctorsModal} centered toggle={() => this.setState({ doctorsModal: !this.state.doctorsModal })} >
                            <ModalHeader toggle={() => this.setState({ doctorsModal: !this.state.doctorsModal })} close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.setState({ doctorsModal: !this.state.doctorsModal })}><Isvg src={xIcon} /></button>}>{'Choose doctors'.translate(this.props.lang)}</ModalHeader>

                            <ModalBody className="run-modal">

                                {
                                    this.state.doctors && this.state.doctors.length && this.state.doctors.filter((item) => {
                                        if (item._id != this.state.doctorId) {
                                            return true;
                                        } else {
                                            return false;
                                        }
                                    }).length ?
                                        <FormGroup >
                                            <Label>{'Search'.translate(this.props.lang)}</Label>
                                            <Input type='text' value={this.state.filterDoctors ? this.state.filterDoctors : ''} onChange={(e) => {
                                                this.setState({
                                                    filterDoctors: e.target.value
                                                })
                                            }} />

                                        </FormGroup>
                                        :
                                        null
                                }

                                <FormGroup >
                                    {
                                        this.state.doctors && this.state.doctors.length && this.state.doctors.filter((item) => {
                                            if (item._id != this.state.doctorId) {
                                                return true;
                                            } else {
                                                return false;
                                            }
                                        }).length ?
                                            <DoctorListComponent

                                                value={this.state.doctorsList ? this.state.doctorsList : []}
                                                values={this.state.doctors.filter(el =>
                                                    (!this.state.event || (this.state.event && this.state.event.patientId != el._id))
                                                ).sort((a, b) => {
                                                    const nameA = a.name;
                                                    const nameB = b.name;
                                                    if (nameA < nameB) {
                                                        return -1
                                                    }
                                                    if (nameA > nameB) {
                                                        return 1
                                                    }
                                                }).filter(doc => doc._id !== this.state.doctorId && doc.name.toLowerCase().indexOf(this.state.filterDoctors ? this.state.filterDoctors.toLowerCase() : ' ') != -1).map(item => {
                                                    return ({
                                                        name: item.name,
                                                        value: item._id,
                                                        profilePicture: item.profilePicture,
                                                        username: item.username
                                                    })
                                                })}
                                                onChange={(item) => {
                                                    let doctorsList = this.state.doctorsList;
                                                    doctorsList = [...item]
                                                    this.setState({ doctorsList })
                                                }}
                                            />

                                            :
                                            "The doctor's list is empty".translate(this.props.lang)
                                    }
                                </FormGroup>


                            </ModalBody>
                            <ModalFooter className='buttons-right-blue'>
                                {
                                    this.state.doctors && this.state.doctors.length && this.state.doctors.filter((item) => {
                                        if (item._id != this.state.doctorId) {
                                            return true;
                                        } else {
                                            return false;
                                        }
                                    }).length ?
                                        <Button color='primary'
                                            onClick={() =>
                                                this.checkDoctorsAvailable(this.state.doctorsList, this.state.doctorsModal)
                                            }>{'Add'.translate(this.props.lang)}</Button>
                                        :
                                        null
                                }
                                <Button color='primary' onClick={() => {
                                    this.setState({ doctorsModal: false })
                                }
                                }>{"Close".translate(this.props.lang)}</Button>
                            </ModalFooter>
                        </Modal>
                        :
                        null
                }
                {
                    this.state.error ?

                        <ErrorModal lang={this.props.lang}
                            isOpen={this.state.error}
                            toggle={() => this.setState({ error: null })}
                        >
                            {this.state.error}
                        </ErrorModal>

                        :
                        null
                }
                {
                    this.state.wrongDate ?
                        <Modal isOpen={this.state.wrongDate} centered>
                            <ModalBody className="delete-modal">
                                <p className='message'>{'You can not pick date form the past'.translate(this.props.lang)}</p>
                            </ModalBody>
                            <ModalFooter className="buttons-right-blue">
                                <Button style={{ minWidth: 100 }} color='primary' onClick={() => this.setState({ wrongDate: !this.state.wrongDate })}>{'Pick again'.translate(this.props.lang)}</Button>
                            </ModalFooter>
                        </Modal>
                        : null
                }
                {
                    this.state.errorAdditionalDoctors ?

                        <ErrorModal lang={this.props.lang}
                            isOpen={this.state.errorAdditionalDoctors}
                            toggle={() => {

                                this.setState({ errorAdditionalDoctors: null })
                            }}

                        >
                            {
                                this.state.errorAdditionalDoctors && this.state.errorAdditionalDoctors.map((item, idx) => {
                                    return (
                                        <div>
                                            <span style={{ fontWeight: 600 }}>
                                                {item.doctorName}  {' - '}
                                            </span>

                                            {
                                                item.available ?
                                                    <span style={{ color: 'green' }}>{'Available'.translate(this.props.lang)}</span>
                                                    :
                                                    <span style={{ color: 'red' }}>{'Unavailable'.translate(this.props.lang)}</span>
                                            }

                                        </div>
                                    )
                                })

                            }
                        </ErrorModal>
                        :
                        null
                }
                {
                    this.state.showPatientNotes ?
                        <PatientNotesPreview
                            {...this.props}
                            isOpen={this.state.showPatientNotes}
                            items={this.state.patientNotes}
                            toggle={() => this.setState({ showPatientNotes: !this.state.showPatientNotes })}
                            showInModal={true}
                        />
                        :
                        null
                }
                {

                    this.state.deleteEventModal ?
                        <Modal isOpen={this.state.deleteEventModal} centered >
                            <ModalBody className="delete-modal">
                                <div className='message' style={{ padding: 20 }}>
                                    {'Do you want to delete this event?'.translate(this.props.lang)}
                                </div>
                            </ModalBody>
                            <ModalFooter
                                className='modal-footer-buttons-wrap'
                                style={{ justifyContent: 'center' }}
                            >
                                <Button
                                    disabled={this.state.loadingDelete}
                                    color='primary'
                                    onClick={() => {
                                        const eventId = this.state.deleteEventModal?._id ?? null;
                                        this.deleteEvent(eventId);
                                    }}
                                >
                                    {'Continue'.translate(this.props.lang)}
                                </Button>
                                <Button
                                    color='primary'
                                    onClick={() => this.setState({ deleteEventModal: !this.state.deleteEventModal })}>
                                    {'Go back'.translate(this.props.lang)}
                                </Button>

                            </ModalFooter>
                        </Modal>
                        :
                        null
                }

                {
                    this.state.leaveCaseModal ?
                        <Modal isOpen={this.state.leaveCaseModal} centered >
                            <ModalBody className="delete-modal">
                                <div className='message'>
                                    {'Do you want to leave the case'.translate(this.props.lang)}
                                </div>
                            </ModalBody>
                            <ModalFooter className='buttons-right-blue'>
                                <Button
                                    color='primary'
                                    style={{ margin: 10, minWidth: 100 }}
                                    disabled={this.state.loading}
                                    onClick={() => {
                                        this.leaveCase()
                                    }}
                                >
                                    {'Yes'.translate(this.props.lang)}
                                </Button>
                                <Button
                                    color='primary'
                                    style={{ margin: 10, minWidth: 100 }}
                                    onClick={() => {
                                        this.setState({ leaveCaseModal: !this.state.leaveCaseModal })
                                    }}
                                >
                                    {'No'.translate(this.props.lang)}
                                </Button>
                            </ModalFooter>
                        </Modal>

                        : null
                }
                {
                    this.state.transferModal ?
                        <Modal
                            isOpen={this.state.transferModal}
                            centered
                        >
                            <ModalHeader
                                toggle={() => this.setState({ transferModal: !this.state.transferModal, timeErrorMessage: null })}
                                close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.setState({ transferModal: !this.state.transferModal, timeErrorMessage: null })}>&times;</button>}
                            >
                                {'Transfer event'.translate(this.props.lang)}
                            </ModalHeader>

                            <ModalBody>
                                <FormGroup>
                                    <Label>{'Doctors'.translate(this.props.lang)}</Label>
                                    <Input
                                        value={this.state.transferModal.doctor ? this.state.transferModal.doctor : -1}
                                        type='select'
                                        onChange={e => {
                                            let transferModal = this.state.transferModal;
                                            const doctorId = e.target.value == -1 ? null : e.target.value;
                                            transferModal.doctor = doctorId;
                                            this.setState({
                                                transferModal
                                            }, () => {
                                                if (doctorId)
                                                    this.getWorkingHours(doctorId, () => {
                                                        this.disableTransferIfTimeIsOutOfWorkingHours();
                                                    });
                                            })

                                        }}
                                    >
                                        <option value={-1}>{'None'.translate(this.props.lang)}</option>

                                        {this.state.doctors.filter(el => el._id != this.state.transferModal.patientId && el._id != this.state.event?.doctor).sort((a, b) => {
                                            const nameA = a.name.toLowerCase();
                                            const nameB = b.name.toLowerCase();
                                            if (nameA < nameB) {
                                                return -1
                                            }
                                            if (nameA > nameB) {
                                                return 1
                                            }
                                        }).map(item => {
                                            let obj = {}
                                            obj.min = new Date()
                                            obj.min.setHours(7, 0, 0)
                                            obj.max = new Date()
                                            obj.max.setHours(18, 0, 0)
                                            if (item.workingTimeConfig) {
                                                if (item.workingTimeConfig[this.props.selectedGroup] && item.workingTimeConfig[this.props.selectedGroup][this.props.selectedClinic]) {
                                                    let minTime = item.workingTimeConfig[this.props.selectedGroup][this.props.selectedClinic].min
                                                    let maxTime = item.workingTimeConfig[this.props.selectedGroup][this.props.selectedClinic].max
                                                    obj.min = new Date();
                                                    obj.min.setHours(new Date(minTime).getHours(), new Date(minTime).getMinutes(), 0)
                                                    obj.max = new Date();
                                                    obj.max.setHours(new Date(maxTime).getHours(), new Date(maxTime).getMinutes(), 0)
                                                }
                                            } else if (this.props.uData && this.props.selectedGroup && this.props.selectedClinic) {
                                                if (groupData?.bookingSettings) {
                                                    const bookingSettings = groupData.bookingSettings;
                                                    if (bookingSettings?.workingHours && bookingSettings?.workingHours.min && bookingSettings?.workingHours.max) {
                                                        obj.min = new Date(this.props.getStringDateTs(Math.floor(new Date(bookingSettings?.workingHours.min)?.getTime() / 1000), 'MM/DD/YYYY HH:mm'))
                                                        obj.max = new Date(this.props.getStringDateTs(Math.floor(new Date(bookingSettings?.workingHours.max)?.getTime() / 1000), 'MM/DD/YYYY HH:mm'))
                                                    }
                                                }
                                            }
                                            return <option value={item._id}>
                                                {item.userData && item.userData.title && item.userData.name ? this.props.formatName(item?.userData?.title, item?.userData?.name) : item.name} - {item.username}    ({this.props.getStringDateTs(Math.floor(obj?.min?.getTime() / 1000), 'HH:mm')} - {this.props.getStringDateTs(Math.floor(obj?.max?.getTime() / 1000), 'HH:mm')})
                                            </option>

                                        })}

                                    </Input>
                                </FormGroup>
                                <FormGroup>
                                    <Label>{'Title'.translate(this.props.lang)}</Label>
                                    <Input
                                        disabled
                                        type='textarea'
                                        value={this.state.transferModal.titleDoctor && this.state.transferModal.titleDoctor != '' ? this.state.transferModal.title + ', ' + this.state.transferModal.titleDoctor : this.state.transferModal.title}
                                    />
                                    <Input
                                        type='text'
                                        style={{ marginTop: 5 }}
                                        onChange={(e) => {
                                            let transferModal = this.state.transferModal;
                                            transferModal.titleDoctor = striptags(e.target.value);
                                            this.setState({
                                                transferModal
                                            })
                                        }}
                                        value={this.state.transferModal.titleDoctor}
                                    />

                                </FormGroup>
                                <DatePicker
                                    label={'Start date'.translate(this.props.lang)}
                                    value={this.state.transferModal.date}
                                    holidayEvents={this.state.holidayEvents}
                                    lang={this.props.lang}
                                    onChange={(e) => {
                                        let transferModal = this.state.transferModal;
                                        transferModal.date = e;
                                        this.setState({
                                            transferModal
                                        })
                                        if (Math.floor(new Date(this.state.transferModal.date + ' ' + this.state.transferModal.startTime) / 1000) > Math.floor(new Date(this.state.transferModal.endDate + ' ' + this.state.transferModal.endTime) / 1000)) {
                                            transferModal.endDate = this.state.transferModal.date
                                            this.setState({
                                                transferModal
                                            })
                                        }
                                    }}
                                />
                                <FormGroup className="timepicker-container timepicker-wide">
                                    <Label>{'Start time'.translate(this.props.lang)}</Label>
                                    &nbsp;
                                    <TimePickerV2
                                        disabled={!this.state.transferModal.doctor}
                                        getStringDateTs={this.props.getStringDateTs}
                                        format={'HH:mm'}
                                        value={this.state.transferModal.startTime}
                                        minValue={minTransferDoctor}
                                        maxValue={addMinutesToTime(maxTransferDoctor, -5)}
                                        flag={0}
                                        onChange={(time1, timeString) => {

                                            let transferModal = this.state.transferModal;
                                            transferModal.startTime = timeString

                                            let startTimeSplit = transferModal.startTime.split(":");
                                            let endTimeSplit = transferModal.endTime.split(":");

                                            let startTimeHourMinute = Number(startTimeSplit[0]) * 60 + Number(startTimeSplit[1]);
                                            let endTimeHourMinute = Number(endTimeSplit[0]) * 60 + Number(endTimeSplit[1]);
                                            this.setState({ transferModal })

                                            if (startTimeHourMinute < endTimeHourMinute) {
                                                this.setState({ transferModal }, () => {
                                                    this.disableTransferIfTimeIsOutOfWorkingHours()
                                                })
                                            } else {
                                                transferModal.endTime = Math.trunc((Number(this.state.transferModal.startTime.split(':')[0]) * 60 + Number(this.state.transferModal.startTime.split(':')[1]) + 5) / 60) + ":" + (Number(this.state.transferModal.startTime.split(':')[0]) * 60 + Number(this.state.transferModal.startTime.split(':')[1]) + 5) % 60
                                                const padded = transferModal?.endTime?.split?.(':');
                                                if (padded && Array.isArray(padded) && padded.length && isStringAValidNumber(padded[0]) && isStringAValidNumber(padded[1])) {
                                                    const h = padded[0]?.padStart?.(2, '0');
                                                    const m = padded[1]?.padStart?.(2, '0');
                                                    if (h && m) transferModal.endTime = `${h}:${m}`;
                                                }
                                                this.setState({
                                                    transferModal
                                                }, () => {
                                                    this.disableTransferIfTimeIsOutOfWorkingHours()
                                                })
                                            }
                                        }}
                                    />

                                </FormGroup>
                                <FormGroup className="timepicker-container timepicker-wide">
                                    <Label>{'End time'.translate(this.props.lang)}</Label>
                                    &nbsp;
                                    <TimePickerV2
                                        disabled={!this.state.transferModal.doctor}
                                        getStringDateTs={this.props.getStringDateTs}
                                        format={'HH:mm'}
                                        value={this.state.transferModal.endTime}
                                        minValue={Math.trunc((Number(this.state.transferModal.startTime.split(':')[0]) * 60 + Number(this.state.transferModal.startTime.split(':')[1]) + 5) / 60) + ":" + (Number(this.state.transferModal.startTime.split(':')[0]) * 60 + Number(this.state.transferModal.startTime.split(':')[1]) + 5) % 60}
                                        maxValue={maxTransferDoctor}
                                        flag={0}
                                        onChange={(time1, timeString) => {

                                            let transferModal = this.state.transferModal;
                                            transferModal.endTime = timeString

                                            let startTimeSplit = transferModal.startTime.split(":");
                                            let endTimeSplit = transferModal.endTime.split(":");

                                            let startTimeHourMinute = Number(startTimeSplit[0]) * 60 + Number(startTimeSplit[1]);
                                            let endTimeHourMinute = Number(endTimeSplit[0]) * 60 + Number(endTimeSplit[1]);

                                            if (startTimeHourMinute < endTimeHourMinute) {
                                                this.setState({ transferModal }, () => {
                                                    this.disableTransferIfTimeIsOutOfWorkingHours()
                                                })
                                            } else {
                                                //this.setState({ wrongInput: true })
                                            }
                                        }}
                                    />
                                </FormGroup>
                                {
                                    this.state.timeErrorMessage ?
                                        <p style={{ color: 'red' }}>{this.state.timeErrorMessage}</p>
                                        :
                                        null
                                }


                                <Button
                                    color='primary'
                                    disabled={!this.state.timeErrorMessage && this.state.transferModal.doctor && !this.state.loadingTransfer ? false : true}
                                    style={{ margin: 10 }}
                                    onClick={() => {
                                        this.transferEvent()
                                    }}
                                >
                                    {'Transfer doctor'.translate(this.props.lang)}
                                </Button>
                                <Button
                                    color='primary'
                                    style={{ margin: 10 }}
                                    onClick={() => this.setState({ transferModal: !this.state.transferModal })}
                                >
                                    {'Cancel'.translate(this.props.lang)}
                                </Button>

                            </ModalBody>
                        </Modal>
                        : null
                }
                {
                    this.state.openPreviewReferral ?
                        <ReferralContent
                            {...this.props}
                            data={caseData}
                            screen={'my-cases'}
                            calendar={true}
                            doctorPage={true}
                            enterprise={enterprise}
                            closeCase={() => { this.setState({ closeCase: true }) }}
                            deleteCase={() => { this.setState({ deleteCase: true }) }}
                            previewAnswersRevisit={(form) => {
                                return;
                            }}
                            closeReferralContent={(data) => {
                                if (this.state.openPreviewReferral) {
                                    this.setState({
                                        openPreviewReferral: null
                                    })
                                }
                            }}
                            setData={(data, refresh = false) => {
                                if (data) {
                                    let caseData = this.state.caseData;
                                    if (data && Object.keys(data)?.length) {
                                        for (var key in data) {
                                            caseData[key] = data[key];
                                        }
                                        this.setState({
                                            openPreviewReferral: false,
                                            caseData: caseData
                                        }, () => {
                                            if (refresh) {
                                                this.toggle();
                                            }
                                        })
                                    }
                                }
                            }}
                        />
                        :
                        null
                }
                {
                    this.state.closeCase ?
                        <Modal isOpen={this.state.closeCase} centered>
                            <ModalBody className="delete-modal">
                                <p className="message">{`Are you sure you want to close the case?`.translate(this.props.lang)}</p>
                            </ModalBody>
                            <ModalFooter className='buttons-right-blue'>
                                <Button color="primary" style={{ margin: 10, minWidth: 100 }} onClick={() => this.setState({ closeCase: false }, () => this.closeReferral())}>{'Yes'.translate(this.props.lang)}</Button>
                                <Button color="primary" style={{ margin: 10, minWidth: 100 }} onClick={() => this.setState({ closeCase: false })}>{'No'.translate(this.props.lang)}</Button>

                            </ModalFooter>
                        </Modal>
                        :
                        null
                }
                {
                    this.state.closeCaseActionModal ?
                        <ErrorModalV2
                            isOpen={this.state.closeCaseActionModal}
                            modalFooterClassName={'modal-footer-buttons-wrap'}
                            buttons={[
                                {
                                    text: 'Close case and keep calendar post'.translate(this.props.lang),
                                    onClick: () => {
                                        const data = this.state.closeCaseActionModal?.data;
                                        const func = this.state.closeCaseActionModal?.function;
                                        this.setState({ closeCaseActionModal: false }, () => {
                                            if (func === 'closeReferral') {
                                                this.closeReferral(data, 'keepCalendarPost');
                                            }
                                        })
                                    }
                                },
                                {
                                    text: 'Close case and delete calendar post'.translate(this.props.lang),
                                    onClick: () => {
                                        const data = this.state.closeCaseActionModal?.data;
                                        const func = this.state.closeCaseActionModal?.function;
                                        this.setState({ closeCaseActionModal: false }, () => {
                                            if (func === 'closeReferral') {
                                                this.closeReferral(data, 'deleteCalendarPost');
                                            }
                                        })
                                    }
                                },
                                {
                                    text: 'Cancel'.translate(this.props.lang),
                                    onClick: () => {
                                        this.setState({ closeCaseActionModal: false })
                                    }
                                }
                            ]}
                        >
                            {'Do you also want to delete the calendar post?'.translate(this.props.lang)}
                        </ErrorModalV2>
                        :
                        null
                }
                {
                    this.state.deleteCase ?
                        <Modal isOpen={this.state.deleteCase} centered>
                            <ModalBody className="delete-modal">
                                <p className="message">{`Are you sure you want to delete the case?`.translate(this.props.lang)}</p>
                            </ModalBody>
                            <ModalFooter className='buttons-right-blue'>
                                <Button color="primary" style={{ margin: 10, minWidth: 100 }} onClick={() => this.setState({ deleteCase: false }, () => this.deleteReferral())}>{'Yes'.translate(this.props.lang)}</Button>
                                <Button color="primary" style={{ margin: 10, minWidth: 100 }} onClick={() => this.setState({ deleteCase: false })}>{'No'.translate(this.props.lang)}</Button>

                            </ModalFooter>
                        </Modal>
                        : null
                }
                {
                    this.state.statusHistoryModal ? <ReferralStatusHistoryModal
                        isOpen={this.state.statusHistoryModal}
                        onClose={() => this.setState({ statusHistoryModal: null })}
                        history={this.state.statusHistoryModal._id}
                        lang={this.props.lang}
                        country={this.props.country}
                        getStringDateTs={this.props.getStringDateTs}
                    /> : null
                }

                {
                    this.state.wrongDateModal ?
                        <InfoModal
                            isOpen={this.state.wrongDateModal}
                            onClose={(item) => {
                                this.setState({
                                    wrongDateModal: null
                                })
                            }}
                            info={"This event has already occurred.".translate(this.props.lang)}
                            buttons={[
                                <Button
                                    // color='success'
                                    style={{ margin: 10, border: 'none' }}
                                    onClick={() => {
                                        this.updateAdministrativeBooking(true);
                                    }}
                                >
                                    {"Save".translate(this.props.lang)}
                                </Button>,
                                <Button
                                    // color='danger'
                                    style={{ margin: 10, border: 'none' }}
                                    onClick={() => {
                                        this.setState({
                                            wrongDateModal: null,
                                            creatingEvent: null,
                                        })
                                    }}
                                >
                                    {'Go back'.translate(this.props.lang)}
                                </Button>,
                            ]}
                        />
                        :
                        null
                }



            </>


        )
    }
}

export default UpdateAdministrativeBooking;